import SubTimeInterval from './SubTimeInterval';

export default SubTimeInterval;
